module.exports = __webpack_public_path__ + "static/media/Gloom_gaussian2.dc180855.png";